import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { currentCohortPathSelector } from '../Auth/selectors';
import { cohortSchedulesSelector } from './selectors.common';

export const currentCohortCohortScheduleSelector = createSelector(
  currentCohortPathSelector,
  cohortSchedulesSelector,
  (cohortPath, cohortSchedules) =>
    cohortSchedules.get(cohortPath, Immutable.Map())
);

export const currentCohortScheduleSelector = createSelector(
  currentCohortCohortScheduleSelector,
  (cohortSchedule) => cohortSchedule.get('schedule', Immutable.Map())
);

export const currentCohortModuleStartDatesSelector = createSelector(
  currentCohortCohortScheduleSelector,
  (cohortSchedule) => {
    let moduleStartDates = Immutable.Map();

    cohortSchedule.get('moduleStartdates', Immutable.List()).forEach((ms) => {
      ms.forEach((startDate, moduleId) => {
        moduleStartDates = moduleStartDates.set(moduleId, startDate);
      });
    });

    return moduleStartDates;
  }
);

export const currentCohortSchedulingListByPagePathSelector = createSelector(
  currentCohortCohortScheduleSelector,
  (cohortSchedule) => {
    let schedulingList = Immutable.Map();

    cohortSchedule
      .get('schedulingList', Immutable.List())
      .forEach((schedule) => {
        schedulingList = schedulingList.set(schedule.get('pagePath'), schedule);
      });

    return schedulingList;
  }
);
